var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.found)?_c('div',{staticClass:"home"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))]),_c('Result',{attrs:{"quiz":_vm.quiz,"rawAnswer":null,"title":_vm.title}})],1):_c('p',[_vm._v("質問は見つかりませんでした")])}
var staticRenderFns = []

export { render, staticRenderFns }